import React from 'react';
import homePageImg from '../images/landing_page_design.png';
import paddy from '../images/paddy1.jpeg'
import potato from '../images/potato.jpeg'
import HomeDescription from './HomeDescription'
import FooterComponent from './Footer';
import NavbarComponent from './Navbar'
import { FaWhatsapp } from 'react-icons/fa'
import Mission from '../components/Mission';
import { COMMON_CONSTANTS } from '../constants/Common'
import Seo from '../components/Seo'
import CaroselHome from '../components/CaroselHome';

import('../css/Home.css');

// const whatsappIcon = { Icon: FaWhatsapp, url: "https://wa.me/8452912071", label: "WhatsApp" }
const { config: { phone } } = COMMON_CONSTANTS

const whatsappLink = `https://wa.me/${phone}`


const HomePage = () => {
    return (
        <>
            <Seo
                title="KhetBazaar | Home"
                description="Buy, sell or lease agricultural, residential, and commercial land across India."
                canonical="https://khetbazaar.in/"
            />

            <div className="homePageContainer">

                <NavbarComponent />
                <a className="whatsapp-float"
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Chat on WhatsApp"
                >
                    <FaWhatsapp size={32} color="#25D366" />
                </a>
                <CaroselHome />

                <div className='description'>
                    <div className='description-text'>
                        <HomeDescription />

                    </div>

                </div>
                <div className='image-container'>
                    <div className="homePageImageContainer">

                        <img className="homePageImage" src={homePageImg} alt="Landing Page" />
                    </div>
                    <div className="homePageImageContainer">
                        <img className='paddyImg' src={paddy} alt='Paddy Img' />
                    </div>
                    <div className="homePageImageContainer">
                        <img className='potatoImg' src={potato} alt='Potato Img' />
                    </div>
                </div>


                <Mission />
                <FooterComponent />


            </div>
        </>
    );
};

export default HomePage;
